export default __webpack_public_path__ + "static/media/help.056c8d92.svg";